import React from 'react';
import { Button } from './ui/button';
import { siteContent } from '../data/mock';

const Hero = ({ onCTAClick }) => {
  const { hero, brand } = siteContent;

  return (
    <section className="hero-section" data-testid="hero-section" data-reveal="rise">
      <div className="container">
        <div className="hero-content">
          <div className="brand-header">
            <img
              src="https://customer-assets.emergentagent.com/job_vivos-no-espirito/artifacts/7a4rtp4g_ChatGPT%20Image%2028%20de%20dez.%20de%202025%2C%2015_12_11.png"
              alt={brand.name}
              className="brand-logo-image"
            />
          </div>

          <div className="hero-grid">
            <div className="hero-text">
              <h1 className="hero-headline" data-testid="hero-headline">{hero.headline}</h1>
              <p className="hero-subheadline">{hero.subheadline}</p>
              <p className="hero-support-text">{hero.supportText}</p>
              <p className="hero-tension-text">{hero.tensionText}</p>
              <Button
                className="cta-button cta-button-hero"
                onClick={onCTAClick}
                size="lg"
                data-testid="hero-cta-button"
              >
                {hero.ctaText}
              </Button>
            </div>

            <div className="hero-image">
              <img
                src="https://customer-assets.emergentagent.com/job_vivos-no-espirito/artifacts/a9v0pps8_5964d6ae-2f58-409b-bedc-b4882e50cc63.png"
                alt="Vivos no Espírito - Produto"
                className="product-mockup-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
